export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/to-shops-bubble.d1d76429-9ccb9b.svg";